import { Link, NavLink, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { ARTIST } from "../data/portfolio";

const NAV = [
  { to: "/animation", label: "Animation" },
  { to: "/paintings", label: "Paintings" },
  { to: "/cards", label: "Cards" },
  { to: "/about", label: "About" },
  { to: "/cv", label: "CV" },
  { to: "/press", label: "Press" },
  { to: "/contact", label: "Contact" },
];

export default function Layout({ children }) {
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  useEffect(() => { setOpen(false); window.scrollTo({ top: 0, behavior: "instant" }); }, [loc.pathname]);

  useEffect(() => {
    const els = document.querySelectorAll(".reveal");
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add("in"); });
    }, { threshold: 0.08 });
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, [loc.pathname]);

  return (
    <div className="min-h-screen grain cursor-arty" data-testid="app-shell">
      <header className="fixed top-0 left-0 right-0 z-40 backdrop-blur-md bg-[rgba(11,10,8,0.6)] border-b hairline">
        <div className="max-w-[1600px] mx-auto px-6 lg:px-10 py-5 flex items-center justify-between">
          <Link to="/" data-testid="brand-link" className="group flex items-center gap-3">
            <span className="font-serif italic text-xl tracking-tight text-[var(--paper)]">{ARTIST.name}</span>
            <span className="hidden md:inline text-xs uppercase tracking-[0.3em] text-[var(--muted)] group-hover:text-[var(--ember)] transition-colors">
              Art Director
            </span>
          </Link>
          <nav className="hidden md:flex items-center gap-7">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.to === "/"}
                data-testid={`nav-${n.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `text-xs uppercase tracking-[0.25em] link-underline transition-colors ${
                    isActive ? "text-[var(--ember)]" : "text-[var(--paper)] hover:text-[var(--ember)]"
                  }`
                }
              >
                {n.label}
              </NavLink>
            ))}
          </nav>
          <button
            data-testid="menu-toggle"
            aria-label="menu"
            className="md:hidden text-[var(--paper)]"
            onClick={() => setOpen((v) => !v)}
          >
            <div className="w-6 flex flex-col gap-[5px]">
              <span className={`h-px bg-current transition-transform ${open ? "translate-y-[6px] rotate-45" : ""}`}></span>
              <span className={`h-px bg-current transition-opacity ${open ? "opacity-0" : ""}`}></span>
              <span className={`h-px bg-current transition-transform ${open ? "-translate-y-[6px] -rotate-45" : ""}`}></span>
            </div>
          </button>
        </div>
        {open && (
          <div className="md:hidden border-t hairline bg-[var(--ink-2)]" data-testid="mobile-menu">
            <div className="px-6 py-6 flex flex-col gap-5">
              {NAV.map((n) => (
                <NavLink key={n.to} to={n.to} end={n.to === "/"} className="text-sm uppercase tracking-[0.3em]">
                  {n.label}
                </NavLink>
              ))}
            </div>
          </div>
        )}
      </header>

      <main className="pt-24">{children}</main>

      <footer className="border-t hairline mt-32">
        <div className="max-w-[1600px] mx-auto px-6 lg:px-10 py-12 flex flex-col md:flex-row md:items-end justify-between gap-8">
          <div>
            <div className="font-serif italic text-3xl md:text-4xl text-[var(--paper)]">{ARTIST.name}</div>
            <div className="text-[var(--muted)] mt-2 text-sm tracking-[0.2em] uppercase">{ARTIST.role}</div>
          </div>
          <div className="flex flex-col md:items-end gap-2 text-sm text-[var(--muted)]">
            <a href={`mailto:${ARTIST.email}`} className="link-underline text-[var(--paper)]" data-testid="footer-email">{ARTIST.email}</a>
            <span>© {new Date().getFullYear()} — All artwork rights reserved.</span>
          </div>
        </div>
      </footer>
    </div>
  );
}
